import * as $ from 'jquery';
import { apiBaseUrlUser } from '../../../constants/url.constant';
import { DefaultService } from '../../common/services/DefaultService';

export class PolicyService extends DefaultService {
    private baseUrl = `${apiBaseUrlUser}/policy`;

    public RouteGetList = () => `${this.baseUrl}/getList`;
    public getList(): JQueryPromise<any> {
        return $.ajax(this.RouteGetList(), {
            type: 'get',
            contentType: 'application/json'
        });
    }
}